/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export default class Error {
  private json: any
  public readonly errorClose: string
  public readonly errorTryAgain: string
  public readonly errorText: string
  public readonly errorTitle: string

  constructor (data: any) {
    this.json = data
    this.errorClose = this.json.close_label
    this.errorTryAgain = this.json.try_again_label
    this.errorText = this.json.error_body
    this.errorTitle = this.json.error_title
  }

  static of (data: any): Error {
    return new Error(data)
  }

  static empty (): Error {
    return new Error({
      close_label: '',
      error_body: '',
      error_title: '',
      try_again_label: ''
    })
  }

  static default (): Error {
    return new Error({
      close_label: 'Close',
      error_body: 'You may want to try again or come back later.',
      error_title: 'Oops! Something went wrong...',
      try_again_label: 'Try again'
    })
  }
}
